import React from 'react';
export function Footer() {
  return <footer className="bg-[#520128] border-t-4 border-[#C9A24A] py-10 px-4 text-center" data-id="element-137" data-mp="32wd2qgad7ltj">
      <p className="text-xs text-white/60 max-w-3xl mx-auto mb-4 leading-relaxed" data-id="element-138" data-mp="3ggtymjf7hl5r">
        Educational teaching-support material for sewing instructors, pattern-making teachers, sewing academies and
        studio workshops. It does not replace an accredited fashion, apparel or sewing curriculum, official
        certifications, your machine manufacturer&apos;s instructions, workplace safety rules or qualified professional
        supervision. Results depend on each instructor, student and learning context; no specific results are
        guaranteed.
      </p>
      <p className="text-sm text-white/80" data-id="element-139" data-mp="3qcx8kbgauo39">© Sewing &amp; Pattern Making Instructor Atlas 2026 — All Rights Reserved.</p>
    </footer>;
}